export const BORDER_REQUIRED_PROPERTIES = ['color', 'width', 'style'] as const;
